"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwSpecDimension = void 0;
/** @TranslateToPython */
var UwSpecDimension;
(function (UwSpecDimension) {
    UwSpecDimension["minimumDownPayment"] = "minimumDownPayment";
    UwSpecDimension["lenderFee"] = "lenderFee";
})(UwSpecDimension || (exports.UwSpecDimension = UwSpecDimension = {}));
